(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pickup-availability-loader"] && !Shopify.designMode) return;
  try {
    class PickupAvailabilityLoader extends HTMLElement {
    connectedCallback() {
      this.target = this.querySelector('[data-pickup-availability-target]');
      this.fetchAvailability(this.dataset.variantId);
      document.addEventListener('variant:change', (event) => {
        if (event.detail && event.detail.variantId) {
          this.fetchAvailability(event.detail.variantId);
        }
      });
    }

    async fetchAvailability(variantId) {
      if (!variantId) return;
      try {
        const url = `${this.dataset.productUrl}?variant=${variantId}&section_id=pickup-availability`;
        const response = await fetch(url);
        const text = await response.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const content = doc.querySelector('.pickup-availability');
        this.target.innerHTML = content ? content.outerHTML : '';
      } catch (error) {
        this.target.innerHTML = '';
      }
    }
  }
  customElements.define('pickup-availability-loader', PickupAvailabilityLoader);
  } catch(e) { console.error(e); }
})();

})();
